import { useState } from "react";
import "./ContactUsPage.css";
import FooterPage from "./FooterPage";
import { connect } from "react-redux";
import uiActions from "../../../redux/ui/action";
import axios from "axios";
import { checkXSSAttackThroughInput } from "../../../custom_utilities/custom_useful_functions"; // Adjust path as needed
import { toastifyMessage } from "../../../custom_utilities/toastify_config"; // Your toast function
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContactUsNavbar from "./ContactUsNavbar";

const ContactUsPage = (props) => {
  const { startLoading, finishLoading } = props;
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name || !/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name =
        "Name is required and should only contain letters and spaces";
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "A valid email is required";
    }
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be exactly 10 digits";
    }
    if (!formData.message) {
      newErrors.message = "Message is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      // Allow only digits and up to 10 characters
      const digitsOnly = value.replace(/\D/g, ""); // Remove non-digit characters
      if (digitsOnly.length > 10) return;
      setFormData({ ...formData, [name]: digitsOnly });
      setErrors({ ...errors, [name]: "" });
      return;
    }

    if (name === "name") {
      // Allow only letters and spaces
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, [name]: lettersOnly });
      setErrors({ ...errors, [name]: "" });
      return;
    }

    // Check for XSS attacks
    const response = await checkXSSAttackThroughInput(value);
    if (!response) return;

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const saveQueryApi = async (requestPayload) => {
    try {
      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/savecontact_details",
        requestPayload
      );
      if (response.data.status === 200) {
        return {
          result: 1,
          data: { message: response.data.message },
        };
      } else {
        return {
          result: 0,
          data: { message: response.data.message },
        };
      }
    } catch (error) {
      console.log(error);
      return {
        result: 0,
        data: { message: "Something went wrong!!!" },
      };
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    const { name, email, mobile, message } = formData;
    const requestPayload = {
      query: `${name}: ${message}`,
      email: email,
      mobile_number: mobile,
    };

    startLoading();
    const returnedResponse = await saveQueryApi(requestPayload);

    if (returnedResponse.result === 1) {
      finishLoading();
      toastifyMessage({
        status: 200,
        message: "Your data has been submitted successfully.",
      });
      setFormData({ name: "", email: "", mobile: "", message: "" });
      setErrors({});
    } else {
      finishLoading();
      toastifyMessage({
        status: 500,
        message:
          returnedResponse.data.message ||
          "Submission failed. Try again later.",
      });
    }
  };

  return (
    <>
      <ContactUsNavbar />
      <div className="contact-us-page">
        <p style={{ textAlign: "center" }}>
          Need help with the app? Submit your support query below and we’ll get
          back to you as soon as possible
        </p>
        <div className="container_page">
          <h2 className="title">Contact Us</h2>
          <div className="formGroup">
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="inputField"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>
          <div className="formGroup">
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="inputField"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className="formGroup">
            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              className="inputField"
              value={formData.mobile}
              onChange={handleChange}
              inputMode="numeric"
              maxLength="10"
            />

            {errors.mobile && <span className="error">{errors.mobile}</span>}
          </div>
          <div className="formGroup">
            <textarea
              name="message"
              placeholder="Please describe the issue you're experiencing with the app."
              className="textareaField"
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && <span className="error">{errors.message}</span>}
          </div>
          <button className="submitButton" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
      <ToastContainer />
      <FooterPage />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(null, mapDispatchToProps)(ContactUsPage);
